// extracted by mini-css-extract-plugin
module.exports = {"imageStyle":"styles_imageStyle__pCYkP","image":"styles_image__DtjkP"};